import axios from 'axios';
import { EventBus } from './event.bus';

const API_URL = process.env.VUE_APP_BASE_API_URL;

export function configureBackend() {

    let realFetch = window.fetch;
    window.fetch = function (url, opts) {

        return new Promise((resolve, reject) => {
            // wrap in timeout to simulate server api call
            setTimeout(() => {

                // authenticate
                if (url.endsWith('/users/authenticate') && opts.method === 'POST') {
                    // get parameters from post request
                
                    let params = JSON.parse(opts.body);
                    return axios
                    .post(API_URL + 'auth/login', {
                      username: params.username,
                      password: params.password
                    })
                        .then(response => {
                            if (response.status === 202) {
                                window.location.replace('/auth/two-factor/verify?ty='+response.data.data.tfa_type+'&q=' + response.data.tfa_token);
                            }
                            if (response.status === 200) {
                                let user = response.data.data;
                                let responseJson = {
                                    user: {
                                        name: user.name,
                                        username: user.username,
                                        email: user.email,
                                        avatar: user.avatar,
                                    },
                                    id: user.id_user,
                                    role: user.role,
                                    token: response.data.access_token,
                                };
                                localStorage.setItem('tokencoba', response.data.access_token);
                                resolve({
                                    ok: true,
                                    text: () => Promise.resolve(JSON.stringify(responseJson))
                                });
                                EventBus.$emit('finlogin', true);    
                            } 
                            return;
                        })
                        .catch(error => {
                            EventBus.$emit('finlogin', false);    
                        if (error.response) {
                            if (error.response.status === 401) {
                                reject(error.response.data.message);
                            }
                            else if(error.response.status === 404) {
                                reject('Server not found.');
                            }
                        } else {
                            reject('Network Error.');
                        }
                    });
                }


                // pass through any requests not handled above
                realFetch(url, opts).then(response => resolve(response));

            }, 500);
        });
    }
}
